import { render } from "./ShippingAddress.vue?vue&type=template&id=81574cea&scoped=true"
import script from "./ShippingAddress.vue?vue&type=script&lang=js"
export * from "./ShippingAddress.vue?vue&type=script&lang=js"

import "./ShippingAddress.vue?vue&type=style&index=0&id=81574cea&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81574cea"]])

export default __exports__